import { Button, Typography } from '@mui/material';
import { FC } from 'react';

type Props = {
  actionText: string;
  actionCallback: () => void;
};

export const FeedbackAlertAction: FC<Props> = (props) => {
  return (
    <Button
      color="inherit"
      size="small"
      disableRipple
      sx={{
        color: 'primary.main',
        minWidth: 'unset',
        padding: '2px 0',
        '&:hover': {
          background: 'none',
          color: 'grey.900'
        }
      }}
      onClick={props?.actionCallback}
    >
      <Typography variant="body2" color="inherit" fontWeight="bold">
        {props?.actionText}
      </Typography>
    </Button>
  );
};
